import { useContext, useEffect } from "react";
import TablaInhabilitada from "./TablaInhabilitada";
import SeleccionContext from "../../../../context/Seleccion/SeleccionContext";

const TablaRegistroInhabilitado = () => {
  const { toasts, getToken } = useContext(SeleccionContext);

  useEffect(() => {
    getToken();
  }, []);

  return (
    <>
      {toasts}
      <TablaInhabilitada />
    </>
  );
};

export default TablaRegistroInhabilitado;
